











import Vue from 'vue';

export default Vue.extend({
    name: "DEmpty",

    props: {
        description: {
            type: String,
            default: "暂无数据"
        }
    }

});

